<script>
import UiBaseIcon from '@/components/icons/UiBaseIcon'
import UiLink from '@/components/UiLink.vue'

export default {
  functional: true,

  render: function (h) {
    return h(
      UiLink,
      {
        class: ['timeline-link'],
        attrs: {
          disabled: true,
          to: { name: 'payments-timeline' },
        },
      },
      [
        h('span', null, 'График платежей'),
        h(
          UiBaseIcon,
          {
            class: ['icon'],
            attrs: {
              'icon-name': 'timeline',
              width: '16px',
              height: '16px',
              color: '#007AFF',
            },
          },
          null
        ),
      ]
    )
  },
}
</script>

<style lang="scss" scoped>
.timeline {
  &-link {
    padding: rem(20px);
    border-left: 1px solid $color-gray-25;

    @include createFlex(flexbox, nowrap, row, flex-start, center, center);

    .icon {
      margin: 0 0 0 rem(10px);
    }

    &[disabled] {
      pointer-events: none;
      opacity: 0.4;
    }
  }
}
</style>
